const SCHEDULED_ORDERS = {
  pageTitle: 'Pedidos Programados',
  pageDescription: 'Entregas programadas',
  guideLabel: 'Como funciona?',
  ordersTable: {
    tableDataNull: 'Nenhum pedido! 👀',
    tableDataLoading: 'Procurando pedidos! 🔍',
    headerRow: {
      orderNumber: 'Número',
      consumerName: 'Nome',
      orderDate: 'Data de emissão',
      orderNeighborhood: 'Bairro',
      orderItems: 'Produtos',
      orderTotalPrice: 'Valor do pedido',
      orderDeliveryDate: 'Data de entrega',
    },
    windowTime: 'às',
  },
  report: {
    button: {
      disabled: 'Recebendo pedidos, seu relatório estará pronto à meia-noite.',
      activated: 'IMPRIMIR RELATÓRIO',
    },
    print: {
      title: 'Relatório de pedidos programados | Entregar em: ',
      checkList: {
        orderNumberLabel: 'Nº: ',
        consumerLabel: 'Cliente: ',
        totalPriceLabel: 'TOTAL: ',
      },
    },
    notification: {
      warning: {
        text: 'Pedidos programados: relatório pronto!',
        link: 'Imprimir relatório',
      },
      delivery: {
        text: 'Pedidos programados: lembrete de entrega!',
        link: 'Ok',
      },
    },
  },
  filter: {
    types: {
      customerName: 'Nome',
      orderNumber: 'Número',
      orderNeighborhood: 'Bairro',
    },
    button: 'Filtrar',
  },
  modal: {
    title: 'CHEGOU PEDIDOS PROGRAMADOS',
    warning: 'Lembre-se: eles foram aceitos automaticamente.',
    printButton: 'IMPRIMIR NOTINHAS',
  },
}

export default SCHEDULED_ORDERS
